function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { PureComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import withTheme from '../withTheme';

var Sidebar = function (_PureComponent) {
  _inherits(Sidebar, _PureComponent);

  function Sidebar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Sidebar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
      collapsed: true
    }, _this.toggleSidebar = function () {
      _this.setState(function (prevState) {
        return {
          collapsed: !prevState.collapsed
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Sidebar.prototype.render = function render() {
    var _props = this.props,
        Link = _props.linkComponent,
        current = _props.current,
        entries = _props.entries,
        theme = _props.theme;
    var collapsed = this.state.collapsed;
    var sidebarClass = collapsed ? 'collapsed' : 'open';
    var sidebarArrowClass = collapsed ? 'collapsed-arrow' : 'open-arrow';
    var sidebarArrowIcon = collapsed ? 'angle-double-right' : 'angle-double-left';
    return React.createElement('div', {
      className: 'sidebar ' + sidebarClass
    }, React.createElement(Link, {
      to: '/',
      className: 'logo-container'
    }, React.createElement('img', {
      className: collapsed ? 'logo-short' : 'logo-full',
      src: theme ? collapsed ? theme.sidebarShortLogo : theme.sidebarFullLogo : 'https://buy.decidata.tv/static/media/' + (collapsed ? 'logo-short.dc660a8b' : 'logo-full.f97ce83c') + '.svg',
      height: '22',
      alt: 'Logo'
    })), entries.map(function (i) {
      return React.createElement(Link, {
        key: i.id,
        to: i.path,
        className: current === i.id ? 'icons-active ' : 'icons '
      }, React.createElement(FontAwesomeIcon, {
        icon: i.icon
      }), !collapsed && React.createElement('p', null, i.label));
    }), React.createElement('div', {
      className: sidebarArrowClass,
      onClick: this.toggleSidebar
    }, React.createElement(FontAwesomeIcon, {
      icon: sidebarArrowIcon
    }), !collapsed && React.createElement('p', null, 'Collapse Sidebar')));
  };

  return Sidebar;
}(PureComponent);

export default withTheme(Sidebar);